var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-dialogue" },
    [
      _c(
        "el-scrollbar",
        {
          class: [
            "c-scrollbar",
            _vm.isShowContent == _vm.CONTENT_MENU.NO_DATA ? "is-blank" : "",
          ],
        },
        [
          _c(
            "div",
            { staticClass: "content_wrap" },
            [
              _vm.isShowContent == _vm.CONTENT_MENU.HAVE_DATA
                ? [
                    _c(
                      "div",
                      { staticClass: "dialogue_list_wrap" },
                      _vm._l(
                        _vm.formModelData.dialogueList,
                        function (item, index) {
                          return _c(
                            "div",
                            {
                              key: item.id + index,
                              ref: `item_${index}`,
                              refInFor: true,
                              staticClass: "dialogue_list_wrap__item",
                              attrs: { "data-custom-id": item.id },
                            },
                            [
                              _vm.formModelData.dialogueList[index] &&
                              _vm.formModelData.dialogueList[index].question &&
                              _vm.formModelData.dialogueList[index].question
                                .type == _vm.qaTypeEnum.Object.QUESTION.code
                                ? [
                                    _c(
                                      "QuestionItem",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              dataProp:
                                                _vm.formModelData.dialogueList[
                                                  index
                                                ].question,
                                              lengthProp:
                                                _vm.formModelData.dialogueList
                                                  .length,
                                              formModalDataProp: item,
                                              index: index,
                                            },
                                            on: {
                                              "open-image-preview": function (
                                                $event
                                              ) {
                                                return _vm.$emit(
                                                  "open-image-preview",
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          "QuestionItem",
                                          _vm.$attrs,
                                          false
                                        ),
                                        _vm.$listeners
                                      )
                                    ),
                                  ]
                                : _vm._e(),
                              _vm.formModelData.dialogueList[index] &&
                              _vm.formModelData.dialogueList[index].answer &&
                              _vm.formModelData.dialogueList[index].answer
                                .type == _vm.qaTypeEnum.Object.ANSWER.code
                                ? [
                                    _c(
                                      "AnswerItem",
                                      _vm._g(
                                        {
                                          attrs: {
                                            dataProp: item.answer,
                                            formModalDataProp: item,
                                            index: index,
                                          },
                                        },
                                        _vm.$listeners
                                      ),
                                      _vm._l(
                                        item.answer.content,
                                        function (e, i) {
                                          return _c("div", {
                                            key: e.id + i,
                                            attrs: { slot: e.type + i },
                                            slot: e.type + i,
                                          })
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        }
                      ),
                      0
                    ),
                  ]
                : _vm._e(),
              _vm.isShowContent == _vm.CONTENT_MENU.NO_DATA
                ? [_c("div", { staticClass: "blank" }, [_vm._v("暂无数据")])]
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }